import MasterService from './MasterService';


export const UserService = {
    ...MasterService,
    
    // createOtp(params){
    //     return this.post('/userAdminAuth/adminlogin',params)
    // },
    VerifyOtp(params){
        return this.post('/userAdminAuth/adminlogin',params)
    },
    createOtp(params){
        return this.post('/userAdminAuth/verifyLogin',params)
    },
    loginCaptcha(){
        return this.get('/userAdminAuth/getCaptchaImage')
    },
    submitBulkUploadIncentive(postData, headers) {
        const url =
          Number(postData.get("type")) === 1
            ? "userAdmin/uploadMarketplaceCSV"
            : "userAdmin/uploadCSV";
        return this.post(url, postData, headers)
    },
    submitPdfUpload(postData, headers){
        return this.post('userAdmin/uploadPDF', postData, headers)
    },
    creatLoginOtp(params){
        return this.post('/userAdminAuth/verifyGoogleLogin',params)
    },
    getUsersList(params){
        return this.post('/user/list-users', params);
    },
    createUser(params){
        return this.post('/user/create-user', params);
    },
    markUserInactive(params){
        return this.post('/user/mark-user-inactive', params);
    },
    updateUser(params){
        return this.post('/user/update-user', params);
    },
}